export const PhxSelectDefaultConfig = {
  optionHeight: 36,
  optionHeightWithSubText: 52,
  groupLabelHeight: 28,
  groupLabelHeightWithFlagOff: 36,
  dividerHeight: 16,
  dropdownSearchInputHeight: 36,
  dropdownFooterHeight: 36,
  maxHeightOfDropdown: 288,
  maxWidthOfDropdown: 360,
  maxItemsBadgeTooltip: 10,
  mobileViewPadding: 8,
};
